// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__28ilf","fullheight":"Loader_fullheight__2rdkR","removed":"Loader_removed__zO9sG","logo":"Loader_logo__3-rpu"};